import { render, staticRenderFns } from "./newstranslations.vue?vue&type=template&id=76204fe0&"
import script from "./newstranslations.vue?vue&type=script&lang=js&"
export * from "./newstranslations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports